<template>
	<div class="container" style="margin-top:150px; z-index:100; min-height:580px;">
    <div class="panel panel-default" style="margin-bottom:0px;">
      <div class="panel-heading" style="background-color: #4b6384; color: white;">
        <h3 class="panel-title">
        <div class="btn-group pull-right">
          <button class="btn dropdown-toggle" data-toggle="dropdown">
            <span class="caret"></span>
          </button>
          <ul class="dropdown-menu dropdown-menu-right">
              <li  v-for="post in posts.slice().reverse()" :key="post.id">
                <router-link class="dropdown-item" :to="{ name: 'blog', params: { id: post.id }}">{{post.title}}</router-link>
              </li>
          </ul>
        </div>
        {{title}}
        </h3>
      </div> 
      <span v-html="template"></span>
	</div>
  </div>
</template>
<script>
import posts from './posts/posts.js'
import {getTemplate} from './posts/content.js'

export default {
  props:['id'],
  data () {
    if(this.id > posts.length){
      this.id = 1
    }
    return {
        title: posts[this.id-1].title,
        posts: posts,
        template: getTemplate(this.id)
    }
  },
  mounted () {
    this.template = getTemplate(this.id);
  },
  watch:{
    id: function(id){
      this.title = this.posts[id-1].title
      this.template = getTemplate(id)
    }
  }

}
</script>
<style>
.blog-img{
    padding: 21px;
    border-radius: 6px;
    box-shadow: -2px -1px 9px 2px #ccc9c9;

}
.panel-body{
    padding:25px;
}
.panel-heading{
    color: #333;
    background-color: #f5f5f5;
    border-color: #ddd;
}
.col-xs-12{
    margin-bottom:20px;
}
.specialli {
        margin: 10px;
        font-size: 17.5px;
}
ol{
    list-style:square;
    margin-left:30px;
    margin-top:20px;
}
.img-responsive {
  display: inline-block;
}

</style>





// WEBPACK FOOTER //
// src/js/components/blogs/Blog.vue